module.exports = __webpack_public_path__ + "img/r2.6bfa784a.png";